import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CommonIcons } from 'components/Icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { checkLinkHttps, isStringHasHTMLTags } from 'helpers';
import NewDesign from '..';
import { SIZE_ICON } from 'consts/data';
import { TooltipReactTooltip } from 'components/Tooltip';

const propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  link: PropTypes.string,
  target: PropTypes.string,
  place: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  style: PropTypes.instanceOf(React.CSSProperties),
  className: PropTypes.string,
};

const Tooltip = ({
  id = '',
  message = '',
  link = '',
  target = '__blank',
  place = 'right',
  className = '',
  style,
  classNameTooltip = '',
  ...restProps
}) => {
  //! State
  const { t } = useTranslation();

  //! Function
  const msgTooltip = useMemo(() => {
    const content = isStringHasHTMLTags(message) ? (
      <NewDesign.Typography dangerouslySetInnerHTML={{ __html: message }} />
    ) : (
      message
    );

    if (link) {
      const isHttpLinks = checkLinkHttps(link);
      return (
        <span>
          <p>{content}</p>
          {isHttpLinks ? (
            <a className='tooltip-link' href={link} target={target}>
              {t('shared:learn_more')}
            </a>
          ) : (
            <Link className='tooltip-link' to={link} target={target}>
              {t('shared:learn_more')}
            </Link>
          )}
        </span>
      );
    }

    return content;
  }, [t, target, message, link]);

  //! Render
  return (
    <TooltipReactTooltip
      {...restProps}
      idTarget={id}
      messageToolTip={msgTooltip}
      place={place}
      delayShow={600}
    >
      <CommonIcons.Tooltip className={className} style={style} size={18} />
    </TooltipReactTooltip>
  );
};

Tooltip.propTypes = propTypes;
export default React.memo(Tooltip);
